function ContactSection({
  formData,
  submitted,
  submitStatus,
  submitMessage,
  onFieldChange,
  onFormSubmit,
}) {
  return (
    <section className="section contact-section reveal" id="contact">
      <div className="contact-copy">
        <span className="section-kicker">Контакты</span>
        <h2>Опишите задачу, Chinatao соберет единое решение</h2>
        <p>
          Виза, выставка или поездка в Китай могут быть в одной заявке.
          Чем точнее детали, тем быстрее мы предложим понятный план, сроки и следующий шаг.
        </p>
        <div className="contact-lines">
          <a className="phone" href="https://wa.me/996509898811" target="_blank" rel="noopener noreferrer">+996 509 89 88 11</a>
          <a className="phone" href="https://wa.me/996558898811" target="_blank" rel="noopener noreferrer">+996 558 89 88 11</a>
          <a className="phone" href="https://wa.me/996707898811" target="_blank" rel="noopener noreferrer">+996 707 89 88 11</a>
          <a className="email" href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent('chinataokgz@gmail.com')}`} target="_blank" rel="noopener noreferrer">chinataokgz@gmail.com</a>
          <a href="https://go.2gis.com/KrNFi" target="_blank" rel="noopener noreferrer">Улица Байтик баатыра-98, Vefa Center блок B, 8 этаж, 403 кабинет</a>
        </div>

        <div className="contact-note-card">
          <h3>какие данные нужно внести</h3>
          <ul>
            <li>тип визы и цель поездки;</li>
            <li>сроки и количество участников;</li>
            <li>нужны ли дополнительно логистика, встречи или сопровождение.</li>
          </ul>
        </div>
      </div>

      <form className="request-form" onSubmit={onFormSubmit}>
        <div className="form-grid">
          <label className="field">
            <span>Имя и фамилия</span>
            <input
              type="text"
              value={formData.name}
              onChange={(event) => onFieldChange('name', event.target.value)}
              placeholder="Например: Алина Ким"
              required
            />
          </label>

          <label className="field">
            <span>Телефон</span>
            <input
              type="tel"
              value={formData.phone}
              onChange={(event) => onFieldChange('phone', event.target.value)}
              placeholder="+996 500 000 000"
              required
            />
          </label>

          <label className="field">
            <span>Email</span>
            <input
              type="email"
              value={formData.email}
              onChange={(event) => onFieldChange('email', event.target.value)}
              placeholder="you@example.com"
            />
          </label>

          <label className="field">
            <span>Тип визы</span>
            <select
              value={formData.visaType}
              onChange={(event) => onFieldChange('visaType', event.target.value)}
            >
              <option>Туристическая</option>
              <option>Бизнес</option>
              <option>Учебная</option>
              <option>Рабочая</option>
              <option>Семейная</option>
            </select>
          </label>

          <label className="field">
            <span>Цель поездки</span>
            <select
              value={formData.tripType}
              onChange={(event) => onFieldChange('tripType', event.target.value)}
            >
              <option>Личная</option>
              <option>Бизнес</option>
              <option>Выставка</option>
              <option>Обучение</option>
              <option>Карго / логистика</option>
            </select>
          </label>

          <label className="field">
            <span>Сроки</span>
            <select
              value={formData.deadline}
              onChange={(event) => onFieldChange('deadline', event.target.value)}
            >
              <option>В течение 3–7 дней</option>
              <option>Срочно</option>
              <option>В течение месяца</option>
              <option>Подбор оптимального варианта</option>
            </select>
          </label>
        </div>

        <label className="field field-full">
          <span>Подробности задачи</span>
          <textarea
            value={formData.comment}
            onChange={(event) => onFieldChange('comment', event.target.value)}
            placeholder="Напишите, что именно нужно: виза, поездка, карго, газон, выставка, количество человек, даты, страна и любые важные детали..."
            rows="5"
          />
        </label>

        <p className="form-hint">Мы ответим с кратким планом действий и перечнем документов.</p>

        <button className="button button-primary" type="submit" disabled={submitStatus === 'loading'}>
          {submitStatus === 'loading' ? 'Отправка...' : 'Отправить заявку'}
        </button>
        {submitMessage && (
          <p className={`form-status form-status-${submitStatus || 'info'}`}>
            {submitMessage}
          </p>
        )}
        {submitted && <p className="form-success">Заявка принята. Менеджер скоро свяжется с вами и уточнит детали.</p>}
      </form>
    </section>
  );
}

export default ContactSection;
